import { render, staticRenderFns } from "./billRecord.vue?vue&type=template&id=c060c164&scoped=true&"
import script from "./billRecord.vue?vue&type=script&lang=js&"
export * from "./billRecord.vue?vue&type=script&lang=js&"
import style0 from "./billRecord.vue?vue&type=style&index=0&id=c060c164&lang=less&scoped=true&"
import style1 from "./billRecord.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c060c164",
  null
  
)

export default component.exports